const mainBell = () => {
  const audio = new Audio("https://bigsoundbank.com/UPLOAD/mp3/1926.mp3");
  audio.play();
}

const lightBell = () => {
  const audio = new Audio("https://bigsoundbank.com/UPLOAD/mp3/0479.mp3");
  audio.play();
}

export { mainBell, lightBell }
